import React, { useEffect, Component, useState } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import { Sidebar } from "../sidebar/Sidebar";
import Navbar from "../navbar/navbar";
import "./reveiwDetail.css";
import profile from "../images/profile.jpg";
import { getUserById } from "../../../Services/users.service";
import _ from "lodash";
import { getReviewByBusinessId, getReviewsByUserId } from "../../../Services/reviews.service";
import { editReview } from "../../../Services/reviews.service";

export const AdminReviewsDetail = (props) => {
  // console.log('--------------',props.location.businessData);
  // return false;
  const [showEditForm, setShowEditForm] = useState(false);
  const [businessData, setBusinessData] = useState(null);
  const [filteredList, setFilteredList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const handleCloseEdit = () => setShowEditForm(false);
  const handleShowEdit = () => setShowEditForm(true);


  if (!!props.location.businessData) {
    
    let _businessData = {};
    _businessData.businessId = props.location.businessData.businessId;
    _businessData.businessName = props.location.businessData.businessName;
    _businessData.totalReviews = props.location.businessData.totalReviews;
    let reviews = props.location.businessData.reviews;
    //console.log(reviews);
    _.forEach(reviews, (r) => {
      getUserById(r.userId).then((u) => {
        if (r.userId == u[0].userId) {
          r.name = u[0].name;
          r.imageUrl = u[0].userImage;
          return r;
        }
      });
    });

    setTimeout(() => {
      _businessData.reviews = reviews;
      setBusinessData(_businessData);
      //console.log(_businessData);
    }, 1000);
  } else if (!!props.location.userId) {
    
    console.log(props.location.userId);
    getReviewsByUserId(props.location.userId).then((u) => {
      console.log(u);
      let _data = {};
      _data.totalReviews = u.length;
      _data.businessName = "";
      _data.reviews = u;
      setBusinessData(_data);
    });
  }else if(!!props.location.businessId)
  {
    
    console.log(props.location.businessId);
    getReviewByBusinessId(props.location.businessId).then((u) => {
      console.log(u);
      let _data = {};
      _data.totalReviews = u.length;
      _data.businessName = "";
      _data.reviews = u;
      setBusinessData(_data);
    });
  }
  useEffect(() => {
  }, []);

  function onValueChange(event, item) {
    var data = businessData;
    //console.log(data);
    _.forEach(data?.reviews, (value) => {
      if (value.reviewId == item.reviewId) {
        value.status = event.target.value;
      }
    });
    setBusinessData(data);
    updateReview(item.reviewId);
  }

  function updateReview(reviewId) {
    var data = businessData;
    //console.log(data);
    _.forEach(data?.reviews, (value) => {
      if (value.reviewId == reviewId) {
        const data = {
          reviewId: value.reviewId,
          status: value.status,
        };
        console.log(data);
        //editReview(data);
      }
    });
  }

  let handleSearchValue = (value) => {
    console.log(value);
    let search = value;
    search = search.trim();
    search = search.toLowerCase();

    if (!!search) {
      setSearchValue(search);
      let localList = [];
      _.forEach(businessData?.reviews, (value) => {
        if (
          _.includes(value.name.toLowerCase(), search) ||
          _.includes(value.description.toLowerCase(), search)
        ) {
          localList.push(value);
        }
      });
      setFilteredList(localList);
    } else {
      setSearchValue(search);
      let localList = [];
      setFilteredList(localList);
    }
  };

  return (
    <>
      {/* Page Wrapper */}
      <div id="wrapper">
        {/* Sidebar */}
        <Sidebar />
        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar setValue={handleSearchValue} />
            <div className="container-fluid">
              <section className="adminReDetailPage">
                {/* Content Row */}
                {businessData ? (
                  <>
                    <div className="row">
                      <div className="col">
                        <h2 className="theme-color">Reviews</h2>

                        <p className="numReview">
                          {businessData?.totalReviews} Reviews {' '}
                          {businessData?.businessName ? `of  ${businessData?.businessName}`: null}
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      {!!searchValue
                        ? filteredList.length > 0
                          ? filteredList.map((item) => {
                              //console.log(item.status);
                              return (
                                <div className="col-6 mb-3">
                                  <div className="detailCard">
                                    <div>
                                      <div className="profileDiv">
                                        <div className="d-flex ai-center">
                                          <div className="">
                                            <img
                                              src={
                                                item.imageUrl
                                                  ? item.imageUrl
                                                  : profile
                                              }
                                              alt="profile"
                                              className="prImg"
                                            />
                                          </div>
                                          <div className="mt-3">
                                            <span className="prName">
                                              {item.name ? item.name : null}
                                            </span>
                                            <span className="time">
                                              {item.dateAdded}
                                            </span>
                                            <p className="">
                                              {item.description}
                                            </p>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="form-check d-flex ml-4">
                                        <span className="mx-5">Status:</span>
                                        {/* className="status-outer" */}
                                        <div>
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            value="pending"
                                            name="status[]"
                                            checked={item.status === "pending"}
                                            onChange={(e) =>
                                              onValueChange(e, item)
                                            }
                                          />
                                          <span>Pending </span>
                                        </div>
                                        <div className="mx-5">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            value="accepted"
                                            checked={item.status === "accepted"}
                                            name="status[]"
                                            onChange={(e) =>
                                              onValueChange(e, item)
                                            }
                                          />
                                          <span>Accepted</span>
                                        </div>
                                        <div className="mx-2">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            value="rejected"
                                            checked={item.status === "rejected"}
                                            name="status[]"
                                            onChange={(e) =>
                                              onValueChange(e, item)
                                            }
                                          />
                                          <span>Rejected</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : null
                        : businessData?.reviews.length > 0
                        ? businessData?.reviews.map((item) => {
                            //console.log(item.status);
                            return (
                              <div className="col-6 mb-3">
                                <div className="detailCard">
                                  <div>
                                    <div className="profileDiv">
                                      <div className="d-flex ai-center">
                                        <div className="">
                                          <img
                                            src={
                                              item.imageUrl
                                                ? item.imageUrl
                                                : profile
                                            }
                                            alt="profile"
                                            className="prImg"
                                          />
                                        </div>
                                        <div className="mt-3">
                                          <span className="prName">
                                            {item.name ? item.name : null}
                                          </span>
                                          <span className="time">
                                            {item.dateAdded}
                                          </span>
                                          <p className="">{item.description}</p>
                                        </div>
                                      </div>

                                      <div className="form-check d-flex ml-4">
                                        <span className="mx-5">Status:</span>
                                        {/* className="status-outer" */}
                                        <div>
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            value="pending"
                                            name="status[]"
                                            checked={item.status === "pending"}
                                            onChange={(e) =>
                                              onValueChange(e, item)
                                            }
                                          />
                                          <span>Pending </span>
                                        </div>
                                        <div className="mx-5">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            value="accepted"
                                            checked={item.status === "accepted"}
                                            name="status[]"
                                            onChange={(e) =>
                                              onValueChange(e, item)
                                            }
                                          />
                                          <span>Accepted</span>
                                        </div>
                                        <div className="mx-2">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            value="rejected"
                                            checked={item.status === "rejected"}
                                            name="status[]"
                                            onChange={(e) =>
                                              onValueChange(e, item)
                                            }
                                          />
                                          <span>Rejected</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        : null}
                    </div>
                  </>
                ) : null}
              </section>
            </div>
            {/* /.container-fluid */}
          </div>
        </div>
      </div>
    </>
  );
};
